/**
 * SVG path masks in 0–100 viewBox (normalized "shields" from reference sheet).
 * Used with AvatarBadge.
 */
export const AVATAR_SHAPE_IDS = [
  'circle',
  'shield_1',
  'shield_2',
  'shield_3',
  'shield_4',
  'shield_5a',
  'shield_5b',
  'shield_6a',
  'shield_6b',
  'shield_7a',
  'shield_7b',
  'shield_8',
] as const;

export type AvatarShapeId = (typeof AVATAR_SHAPE_IDS)[number];

export const DEFAULT_AVATAR_SHAPE: AvatarShapeId = 'shield_7b';

/** Path in viewBox 0 0 100 100 — filled for clip. */
export const AVATAR_SHAPE_PATHS: Record<AvatarShapeId, string> = {
  circle: 'M 50 6 C 74 6 94 26 94 50 C 94 74 74 94 50 94 C 26 94 6 74 6 50 C 6 26 26 6 50 6 Z',
  shield_1: 'M 10 12 L 90 12 L 90 78 L 50 92 L 10 78 Z',
  shield_2: 'M 12 12 L 88 12 L 88 62 Q 50 92 12 62 Z',
  shield_3: 'M 12 12 L 88 12 Q 92 50 50 92 Q 8 50 12 12 Z',
  shield_4: 'M 18 12 L 82 12 L 88 18 L 88 72 L 50 90 L 12 72 L 12 18 Z',
  shield_5a: 'M 15 18 Q 20 8 30 12 L 70 12 Q 80 8 85 18 L 88 70 L 50 90 L 12 70 Z',
  shield_5b: 'M 28 22 L 88 12 L 88 68 Q 50 90 12 68 L 12 35 Q 22 28 28 22 Z',
  shield_6a: 'M 12 22 Q 25 8 50 12 Q 75 8 88 22 L 85 70 L 50 90 L 15 70 Z',
  shield_6b: 'M 8 14 L 92 14 L 86 72 L 50 88 L 14 72 Z',
  shield_7a: 'M 50 6 C 78 6 94 28 94 52 C 94 78 72 94 50 94 C 28 94 6 78 6 52 C 6 28 22 6 50 6 Z',
  shield_7b: 'M 50 6 C 72 6 90 24 90 50 C 90 76 72 94 50 94 C 28 94 10 76 10 50 C 10 24 28 6 50 6 Z',
  shield_8: 'M 14 22 Q 10 40 14 58 L 14 72 L 50 88 L 86 72 L 86 58 Q 90 40 86 22 L 86 12 L 14 12 Z',
};

export function normalizeAvatarShapeId(raw: string | null | undefined): AvatarShapeId {
  if (!raw) return DEFAULT_AVATAR_SHAPE;
  const t = raw.trim() as AvatarShapeId;
  return (AVATAR_SHAPE_IDS as readonly string[]).includes(t) ? t : DEFAULT_AVATAR_SHAPE;
}
